import CubesImg from "public/kubernetes/implementation/fa6-solid_cubes.png";
import RocketImg from "public/kubernetes/implementation/fa6-solid_rocket.png";
import CloudImg from "public/kubernetes/implementation/heroicons_cloud-16-solid.png";
import BoltImg from "public/kubernetes/implementation/material-symbols_bolt-rounded.png";
import GraphImg from "public/kubernetes/implementation/octicon_graph-16.png";
import LastUpdatesImg from "public/kubernetes/implementation/stash_last-updates.png";
import LockOffImg from "public/kubernetes/implementation/tdesign_lock-off-filled.png";
import SecuredImg from "public/kubernetes/implementation/tdesign_secured-filled.png";

export const IMPLEMENTATION_CONSTANTS = {
  title: "Implementing  Kubernetes Clusters",
  desc: "To deploy a  Kubernetes cluster, consider the following steps:",
  list: [
    {
      image: SecuredImg,
      title: "1. Cluster Deployment",
      content:
        "Utilize tools like kubeadm or managed Kubernetes services that support private cluster configurations.",
    },
    {
      image: RocketImg,
      title: "2. Networking Configuration",
      content:
        "Set up network policies to control traffic flow between pods and services, ensuring that only authorized communications occur.",
    },
    {
      image: LockOffImg,
      title: "3. Access Control",
      content:
        "Implement VPNs or bastion hosts to manage secure access to the cluster's API server.",
    },
    {
      image: CubesImg,
      title: "4. Service Exposure",
      content:
        "Configure services for access needs: ClusterIP (internal), NodePort (external via node port), and LoadBalancer (external via cloud load balancer).",
    },
    {
      image: BoltImg,
      title: "5. Persistent Storage",
      content:
        "Implement Persistent Volumes (PV) and Persistent Volume Claims (PVC) for data retention across pod restarts. Kubernetes supports automatic configuration of NFS volume provisioners.",
    },
    {
      image: CloudImg,
      title: "6. DNS Configuration",
      content:
        "Ensure proper DNS setup for internal service discovery using tools like CoreDNS for efficient internal DNS resolution.",
    },
    {
      image: GraphImg,
      title: "7. Monitoring and Logging",
      content:
        "Integrate solutions like Prometheus for monitoring and the ELK Stack for logging to track cluster performance and security events.",
    },
    {
      image: LastUpdatesImg,
      title: "8. Regular Updates and Patching",
      content:
        "Apply regular updates and patches to Kubernetes components and underlying infrastructure to protect against vulnerabilities.",
    },
  ],
};
